/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useRef } from 'react';
import { useSelector } from 'react-redux';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { AuthContext } from '../context';
import { BackIcon, CartIcon, Menu, MenuIcon, MenuLogoutIcon } from '../assets/icons';
import Cart from './cart';

const navigation = [
  {
    id: 1,
    name: 'Inicio',
    href: '/',
    icon: Menu.Menu1,
    iconActive: Menu.Menu1Active,
  },
  {
    id: 2,
    name: 'Perfil',
    href: '/perfil',
    icon: Menu.Menu2,
    iconActive: Menu.Menu2Active,
  },
  {
    id: 3,
    name: 'Solicitudes',
    href: '/solicitudes',
    icon: Menu.Menu4,
    iconActive: Menu.Menu4Active,
  },
  {
    id: 4,
    name: 'Historial de Pagos',
    href: '/historial/pagos',
    icon: Menu.Menu5,
    iconActive: Menu.Menu5Active,
  },
  {
    id: 5,
    name: 'Historial de Productos',
    href: '/historial/productos',
    icon: Menu.Menu3,
    iconActive: Menu.Menu3Active,
  },
  {
    id: 6,
    name: 'Detalles del Producto',
    href: '/productos/:idBase64',
    hidden: true,
  },
  {
    id: 7,
    name: 'Beneficiarios',
    href: '/mi-pedido/beneficiarios',
    hidden: true,
  },
  {
    id: 8,
    name: 'Mi Pedido',
    href: '/mi-pedido',
    hidden: true,
  },
  {
    id: 9,
    name: 'Métodos de Pago',
    href: '/mi-pedido/pagar',
    hidden: true,
  },
  {
    id: 10,
    name: 'Depósito',
    href: '/pagar/deposito',
    hidden: true,
  },
  {
    id: 11,
    name: 'Pago Móvil',
    href: '/pagar/pago-movil/banco',
    hidden: true,
  },
  {
    id: 12,
    name: 'Transferencia',
    href: '/pagar/transferencia',
    hidden: true,
  },
  {
    id: 13,
    name: 'Débito Inmediato',
    href: '/pagar/pago-movil/directo',
    hidden: true,
  },
  {
    id: 14,
    name: 'Zelle',
    href: '/pagar/zelle',
    hidden: true,
  },
  {
    id: 15,
    name: 'Solicitudes',
    href: '/solicitudes',
    hidden: true,
  },
  {
    id: 16,
    name: 'Solicitar Servicio',
    href: '/servicios/solicitar',
    hidden: true,
  },
  {
    id: 17,
    name: 'Historial de Servicios',
    href: '/historial/servicios',
    hidden: true,
  },
];

const Layout = ({ children }) => {
  const cartModalRef = useRef();
  const confirmModalRef = useRef();
  const { user } = useContext(AuthContext);
  const location = useLocation();
  const history = useHistory();
  const cart = useSelector(state => state.cart);

  const routeName = navigation.find(x => {
    const currentParts = location?.pathname?.split('/');
    const pathParts = x.href.split('/');

    if (currentParts.length !== pathParts.length) return false;

    return pathParts.every((item, i) => {
      const _current = currentParts[i];
      return pathParts[i].includes(':') ? !isNaN(+_current) : item === _current;
    });
  })?.name || '';

  const toggleSidebar = () => {
    const items = document.getElementsByClassName('desk-sidebar');
    for (let key = 0; key < items.length; key++) {
      items.item(key).classList.toggle('open');
    }
  }

  return (
    <div id="layout">
      <dialog id="cart-modal" ref={cartModalRef} className="fixed inset-0 z-50 overflow-y-auto bg-transparent">
        <Cart onClose={() => cartModalRef.current.close()} />
      </dialog>

      <dialog ref={confirmModalRef} className="fixed inset-0 z-50 overflow-y-auto bg-transparent">
        <div className="w-[20rem] bg-white rounded-xl overflow-hidden">
          <div className="py-8 px-5">
            <p className="text-center">¿Realmente desea cerrar la sesión?</p>
          </div>

          <div className="flex justify-between h-12 font-semibold">
            <button
              className="flex-1 bg-white p-3"
              onClick={() => confirmModalRef.current?.close()}
            >
              <span>Cancelar</span>
            </button>

            <button className="flex-1" onClick={() => history.replace('/logout')}>
              <span>Aceptar</span>
            </button>
          </div>
        </div>
      </dialog>

      <div className="desk-sidebar desk-sidebar__header">
        <div className="sidebar-logo">
          <div className="sidebar-logo__wrapper">
            <button type="button" className="w-8 h-8 p-1.5 ml-2 flex justify-center items-center bg-darkBlue rounded-lg" onClick={toggleSidebar}>
              <span className="sr-only">Open sidebar</span>
              <img src={MenuIcon} className="w-4 h-4 object-contain" alt="" />
            </button>
          </div>
        </div>
        <div className="desk-headerbar">
          <button type="button" className="lg:hidden w-8 h-8 p-1.5 ml-2 flex justify-center items-center bg-darkBlue rounded-lg" onClick={toggleSidebar}>
            <span className="sr-only">Open sidebar</span>
            <img src={MenuIcon} className="w-4 h-4 object-contain" alt="" />
          </button>

          <div id="header-goback" className="ml-4 hidden" onClick={() => history?.goBack()}>
            <img src={BackIcon} className="w-6 h-6 object-contain cursor-pointer" title="Volver" alt="Volver" />
          </div>

          <div className="h-6 w-px bg-darkBlue" aria-hidden="true" />

          <span id="breadcrumb-content" className="hidden md:block font-medium text-lg">
            { routeName }
          </span>

          <div className="flex flex-1 gap-x-4 self-stretch items-center lg:gap-x-6">
            <div className="relative flex flex-1" />

            <div className="flex items-center gap-x-4 lg:gap-x-6">
              <button id="header-cart" className="relative" onClick={() => cartModalRef.current?.showModal()} title="Ver Carrito">
                <img src={CartIcon} className="w-6 h-6 object-contain" alt="" />
                {cart?.length > 0 && (
                  <span className="w-4 h-4 rounded-full bg-green absolute justify-center items-center -bottom-1 -right-1 text-[11px]">
                    { cart?.length }
                  </span>
                )}
              </button>

              <div className="hidden lg:block lg:h-6 lg:w-px lg:bg-darkBlue" aria-hidden="true" />

              <div className="relative">
                <button onClick={() => confirmModalRef.current?.showModal()} className="focus:outline-none" title="Cerrar sesión">
                  <img src={MenuLogoutIcon} className="w-6 h-6" alt="" style={{ filter: 'brightness(0) invert(1)' }} />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <SideBar />

      <main>
        {!!user && children}
      </main>
    </div>
  )
}

const SideBar = () => {
  const location = useLocation();

  return (
    <div className="desk-sidebar">
      <aside>
        <div className="flex grow flex-col gap-y-5 overflow-y-auto border-r border-gray6 bg-white px-6 pb-4">
          <nav className="flex flex-1 flex-col">
            <ul className="flex flex-1 flex-col -mx-2 space-y-1">
              {navigation.filter(x => !x.hidden).map((item, index) => {
                const isActive = location?.pathname === item.href;
                return (
                  <li key={index} className="menu-item" title={item.name}>
                    <Link to={item.href} className="flex gap-x-3 p-2 leading-6 font-semibold text-text">
                      <img
                        src={isActive ? item.iconActive : item.icon}
                        className="w-6 h-6 object-contain"
                        alt=""
                      />
                      <span>{ item.name }</span>
                    </Link>
                  </li>
                )
              })}
            </ul>
          </nav>
        </div>
      </aside>
    </div>
  )
}

export default Layout;